import React, { Component } from 'react';
import ProjectPage from '../../components/ProjectPage';
import Table from '../../components/Table';
import Banner from '../../images/projects/DefenderTraineeBanner.jpg'

class DefenderTrainee extends Component {
  render() {
    return (
    <ProjectPage title="Defender Trainee" banner={Banner}>

      <div className='project-page-part'>

        <Table className="centered" data={{
          Status : "Finished",
          Type : "School project",
          Engine : "Unreal Engine 5",
          Language : "C++",
          Duration : "3 weeks",
          Team : "Group of 2",
          Date : "2023"
        }}/>

      </div>

      <div className='project-page-part'>

        <h3>Context :</h3>

        <p className='basic-text'>
          Defender Trainee is my first game using C++ with Unreal Engine.<br/>
          The objective of the project was to create a TPS from scratch in Unreal Engine using C++
        </p>

      </div>

      <div className='project-page-part'>

        <h3>Game :</h3>

        <p className='basic-text'>
          Defender Trainee is a basic TPS where you have to shoot a maximum of targets as quickly as possible.
        </p>

      </div>

      <div className='project-page-part'>

        <h3>My contribution :</h3>
        
        <ul className='basic-text'>
          <li>Player movement</li>
          <li>Weapon system</li>
          <li>UI</li>
          <li>Main map</li>
        </ul>
        
      </div>

      <div className='project-page-part'>

        <h3>Gameplay :</h3>

        <iframe className='project-video' title='Defender Trainee demo' allowFullScreen
        src="https://youtube.com/embed/s9OWcE2SSvM">
        </iframe>

      </div>

    </ProjectPage>
    );
  }
}

export default DefenderTrainee;